/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { FormProps } from 'antd'
import { ReactNode } from 'react'

export function FormInputLabel({ children, layout }: { children: ReactNode; layout: FormProps['layout'] }) {
  let rendered = <>{children}</>
  if (layout === 'horizontal') {
    rendered = <span className="sr-only">{children}</span>
  }

  return rendered
}
